var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgThesolution(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 35.43 35.43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ff9500;}.cls-2{fill:none;stroke:#ff9500;stroke-miterlimit:10;stroke-width:2px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_24-Computer-Process",
    "data-name": " 24-Computer-Process"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M25.32,17.17v1.09h-13v-6h5.43V11.2h-6a.54.54,0,0,0-.54.54v6.52H10.11V10.65a.54.54,0,0,1,.54-.54H18.8V9H10.65A1.63,1.63,0,0,0,9,10.65V21.52a.55.55,0,0,0,.55.54h4.8L14,24.78h-.62a.54.54,0,0,0-.54.54H11.74v1.09h12V25.32H22.6a.54.54,0,0,0-.54-.54h-.61l-.39-2.72h4.8a.55.55,0,0,0,.55-.54V17.17ZM15.08,24.78l.39-2.72H20l.38,2.72ZM25.32,21H10.11V19.34H25.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M20.74,13.91l-.69.69.77.77.7-.68a2.14,2.14,0,0,0,.54.23v1.16h1.09V14.92a2.14,2.14,0,0,0,.54-.23l.69.69.77-.76-.68-.71a2.58,2.58,0,0,0,.23-.54h1.16V12.28H24.7a2.14,2.14,0,0,0-.23-.54l.69-.69-.77-.78-.7.69a2.14,2.14,0,0,0-.54-.23V9.57H22.06v1.16a2.14,2.14,0,0,0-.54.23l-.7-.69L20,11l.7.7a2.14,2.14,0,0,0-.23.54H19.34v1.09h1.17A2.14,2.14,0,0,0,20.74,13.91Zm1.86-2.17a1.09,1.09,0,1,1,0,2.17,1.09,1.09,0,0,1,0-2.17Z"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 17.71,
    cy: 17.71,
    r: 16.71
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThesolution);
export default __webpack_public_path__ + "static/media/The solution.b1f0959c02bc758e008db6c423a38d04.svg";
export { ForwardRef as ReactComponent };